import React from 'react';
import WarningIcon from '../../assests/img/warning-icon.svg?react';
import classNames from 'classnames';


interface popupWarningContentProps {
    mainContent: string,
    subContent?: string,
}

function PopupWarningContent(props: popupWarningContentProps) {
    const {mainContent, subContent} = props;
    return (
        <div className='popup-warning-msg'>
            <div className='mb-1 d-flex align-items-center gap-2'>
                <WarningIcon className='align-self-start'/>
                <div>
                    <div className={classNames(subContent ? 'popup-warning-msg-header' : '')}>{mainContent}</div>
                    <div className='popup-warning-msg-content'>{subContent}</div>
                </div>
            </div>
        </div>
    );
}

export default PopupWarningContent;
